import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_roles",
  ref: "rolesModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_roles_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "items" }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            "label-width": "150px",
            model: _ctx.dataForm,
            rules: _ctx.rules,
            "validate-on-rule-change": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form_item, {
                  label: "Tên nhóm quyền:",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.dataForm.cTenNhomQuyen,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataForm.cTenNhomQuyen) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Mô tả :",
                  prop: "remark"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.dataForm.cMoTa,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataForm.cMoTa) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleSave
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Xác nhận")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              onClick: _ctx.handleClose
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Thoát")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ], 512))
}